import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import "./index.css";
import { ReactSortable } from "react-sortablejs";
import ResizableDiv from "./ResizableDiv";

const SortableList = ({ initialItems, onItemsChange, onRender }) => {
  const [items, setItems] = useState(initialItems || []);
  const dataRef = React.useRef(initialItems);
  useEffect(() => {
    setItems(initialItems);
    // console.log('SortableList useEffect',  )
    dataRef.current = initialItems;
  }, [initialItems]);

  return (
    <ReactSortable
      list={items}
      setList={onItemsChange}
      style={{
        position: "relative",
        display: "flex",
        flexWrap: "wrap",
      }}
      group={{
        name: "myDash",
        pull: false,
        put: false
      }}
      animati={150}
      ghostClass="sortable-ghost"
      chosenClass="sortable-chosen"
      dragClass="sortable-drag"
      className={`column-content `}
      handle={".block-head"}
    >
      {items.map((item, index) => {
        // console.log(`item ${item.widgetId}`, item.widgetId, item.width, item.height)
        return (
          <ResizableDiv
            key={`ResizableDiv-${item.widgetId}-${item.width}-${item.height}-${index}`}
            widthpx={item.width * 20}
            heightpx={item.height * 15}
            onResize={(size) => {
              const newItems = dataRef.current.map((res) => {
                if (res.widgetId === item.widgetId) {
                  return {
                    ...res,
                    width: Math.ceil(size.width / 20),
                    height: Math.ceil(size.height / 15),
                  };
                }
                return res;
              });
              onItemsChange(newItems);
              // setItems(newItems);
            }}
          >
            {onRender(item)}
          </ResizableDiv>
        );
      })}
    </ReactSortable>
  );
};

export default withRouter(SortableList);
